import { TPostQueueConfigUserPreference } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function postQueueConfigUserPreferenceForBusiness({
  preferenceFor,
  preferences = { actions: [], columns: [] },
}: TPostQueueConfigUserPreference): Promise<TrystGenericResponse<undefined>> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: JSON.stringify({
        preferenceFor,
        preferences,
      }),
      mode: "cors",
      credentials: "include",
    };

    const response = await fetch(
      `${TRYST_HOST}/business/queue-config/user-preference`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
